import { useEffect } from "react";
import api from "@/lib/api";

/**
 * Loads the AdSense script tag globally based on admin settings.
 * - If `adsense_script` field contains a full <script> tag(s), injects them raw.
 * - Otherwise, if publisher ID is set, injects the standard adsbygoogle loader.
 * Idempotent: won't re-inject on re-render or route changes.
 */
export default function AdSenseLoader() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.__adsenseLoaded) return;

    api
      .get("/settings")
      .then((r) => {
        const s = r.data || {};
        const script = (s.adsense_script || "").trim();
        const pubId = (s.adsense_publisher_id || "").trim();

        if (script) {
          // Extract <script> tag(s) and re-create so they execute
          const parser = new DOMParser();
          const doc = parser.parseFromString(script, "text/html");
          const tags = doc.querySelectorAll("script");
          if (tags.length === 0) {
            // treat as raw inline code
            const s2 = document.createElement("script");
            s2.text = script;
            document.head.appendChild(s2);
          } else {
            tags.forEach((t) => {
              const s2 = document.createElement("script");
              [...t.attributes].forEach((a) => s2.setAttribute(a.name, a.value));
              if (t.text) s2.text = t.text;
              document.head.appendChild(s2);
            });
          }
          window.__adsenseLoaded = true;
        } else if (pubId) {
          const s2 = document.createElement("script");
          s2.async = true;
          s2.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${pubId}`;
          s2.crossOrigin = "anonymous";
          document.head.appendChild(s2);
          window.__adsenseLoaded = true;
        }
      })
      .catch(() => {});
  }, []);

  return null;
}
